import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import Marquee from "react-fast-marquee"
import { classNames } from "./utils"
import PreviewCompatibleImage from "./PreviewCompatibleImage"

// From https://juusomikkonen.com/blog/2016/07/24/animated-onclick-scroller-in-pure-js.html
// Needed for Safari where smooth scroll behavior still isn't available.
const animateScroll = (targetHeight) => {
  targetHeight =
    document.body.scrollHeight - window.innerHeight >
    targetHeight + window.scrollY
      ? targetHeight
      : document.body.scrollHeight - window.innerHeight
  var initialPosition = window.scrollY
  var SCROLL_DURATION = 30
  var step_x = Math.PI / SCROLL_DURATION
  var step_count = 0
  requestAnimationFrame(step)
  function step() {
    if (step_count < SCROLL_DURATION) {
      requestAnimationFrame(step)
      step_count++
      window.scrollTo(
        0,
        initialPosition +
          targetHeight * 0.25 * Math.pow(1 - Math.cos(step_x * step_count), 2)
      )
    }
  }
}

const References = ({ className, withArrow }) => {
  const {
    markdownRemark: {
      frontmatter: { referenceTitle, references },
    },
  } = useStaticQuery(graphql`
    query ReferencesQuery {
      markdownRemark(frontmatter: { id: { eq: "common" } }) {
        frontmatter {
          referenceTitle
          references {
            name
            image {
              publicURL
              svg {
                content
                originalContent
              }
              childImageSharp {
                gatsbyImageData(quality: 100, width: 200)
              }
            }
          }
        }
      }
    }
  `)
  return (
    <div className={classNames("references", className)}>
      <p className="references-title">{referenceTitle}</p>
      <Marquee speed={50} pauseOnHover autofill gradientWidth={100}>
        {references.map((reference) =>
          reference?.image?.svg ? (
            <div
              key={reference.name}
              role="img"
              alt={reference.name}
              className="reference"
              dangerouslySetInnerHTML={{
                __html: reference.image.svg.originalContent,
              }}
            ></div>
          ) : (
            <div className="reference" key={reference.name}>
              <PreviewCompatibleImage
                imageInfo={reference.image}
                placeholder="none"
                loading="eager"
                style={{
                  filter:
                    // Filtered using https://codepen.io/sosuke/pen/Pjoqqp
                    "invert(16%) sepia(9%) saturate(4049%) hue-rotate(199deg) brightness(92%) contrast(88%)",
                }}
              />
            </div>
          )
        )}
      </Marquee>
      {withArrow && (
        <div
          className="triangle-down"
          onClick={() => {
            if (window.CSS.supports("scroll-behavior", "smooth")) {
              window.scrollTo({
                left: 0,
                top: window.innerHeight,
                behavior: "smooth",
              })
            } else {
              animateScroll(window.scrollY + window.innerHeight)
            }
          }}
        />
      )}
    </div>
  )
}

export default References
